/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description React Hook useWriteOffReasons
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * use write off reasons hook
 * @returns {UseQueryResult} useWriteOffReasons
 */
const useWriteOffReasons = (): UseQueryResult<EntitySettings.IWriteOffReasonResponse[]> => {
	return useQuery({
		queryKey: [QUERY_KEYS.writeOffReasons],
		queryFn: async () => {
			const { data } = await api.WriteOffReasonApi.getWriteOffReasons();
			return data;
		},
	});
};

export default useWriteOffReasons;
